import { Validators, AbstractControl } from "@angular/forms";

export function validateEmails(users: {email: string}[]) {
    return users.every((user: any) => {
        // Handle case where user is a string (direct email)
        if (typeof user === 'string') {
            return Validators.email(<AbstractControl>{ value: user.trim() }) == null;
        }
        // Handle case where user is an object with email property
        if (user && user.email !== undefined) {
            return Validators.email(<AbstractControl>{ value: user.email.trim() }) == null;
        }
        // Handle case where email is undefined - this should be invalid
        return false;
    });
}

export function emailsValidator(control: AbstractControl): {emails: boolean} | null {
    let controlVal = control.value;
    if(controlVal){
        controlVal = Array.isArray(control.value) ? controlVal : controlVal.split(',');
        if (control.value === '' || !control.value || validateEmails(controlVal)) {
            return null
        }
        return { emails: true };
    }
    return null;
}